<template>
  <div class="c-domain-setup-form pt-4">

    <div>
      <ListView @open-integration="handleIntegrationOpen"/>
    </div>

    <div class="mt-16 mb-12 flex justify-center text-sm"><strong>Add more <i class="el-icon-bottom"></i></strong></div>

    <div class="w-full p-3 flex items-center gap-2">
      <img src="/integrations/zapier-logo.svg" alt="Zapier Logo"
           width="130" class="mr-4 md:mr-8">
      <div class="w-full flex justify-between">
        <div class="max-w-md flex flex-col gap-y-2">
          <h2 class=" font-bold text-2xl">Use Zapier to integrate this widget with hundreds of other apps</h2>
          <a href="https://onvocado.com/support/integrating-onvocado-with-zapier" class="underline">Read more about
            Exporting data to zapier</a>
        </div>

        <div>
          <button class="btn secondary outline medium m-auto mb-2"
                  type="button"
                  @click.stop="handleIntegrationOpen('', 'ZAPIER')">Add Zapier Webhook
          </button>
        </div>
      </div>
    </div>

    <div class="w-full p-3 flex items-center gap-2">
      <div class="w-40 flex-shrink-0">
        <img src="/integrations/webhook.svg" alt="Webhook Logo"
             class="m-auto">
      </div>

      <div class="w-full flex justify-between">
        <div class="max-w-md flex flex-col gap-y-2">
          <h2 class=" font-bold text-2xl">Use Webhooks to automate data transfers between your applications</h2>
          <a href="https://onvocado.com/support/setting-up-onvocado-webhooks" class="underline">Learn more about how
            Webhooks can streamline your workflows</a>

        </div>

        <div>
          <button class="btn secondary outline medium m-auto mb-2"
                  type="button"
                  @click.stop="handleIntegrationOpen('', 'WEBHOOK')">Add Plain Webhook
          </button>
        </div>
      </div>
    </div>

    <el-drawer
        :size="'70%'"
        :visible.sync="drawerVisible"
        :before-close="handleClose"
        :destroy-on-close="true">
      <div slot="title" class="text-body-black">
        <strong> {{ targetIntegrationID ? '' : 'New' }} <i class="capitalize">{{ targetIntegrationType }}</i>
          integration</strong>
        <hr class="mt-2">
      </div>

      <WebhookOrZapier :target-type="targetIntegrationType"
                       @form-modified="childFormModified = $event"
                       @close-drawer="triggerDrawerClose"
                       @force-close="triggerForceClose"/>
    </el-drawer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ListView from '@components/forms/integrations/ListView.vue'
import WebhookOrZapier from '@components/forms/integrations/WebhookOrZapier.vue'

export default {
  name: 'Integrations',
  components: {
    WebhookOrZapier,
    ListView,
  },
  data() {
    return {
      drawerVisible: false,
      targetIntegrationType: null,
      childFormModified: false,
    }
  },
  computed: {
    ...mapState('integration',
        ['targetIntegrationID']),
  },
  methods: {
    ...mapActions('integration', ['setTargetIntegration']),
    handleIntegrationOpen(id = '', targetIntegration) {
      this.setTargetIntegration(id)
      this.targetIntegrationType = targetIntegration
      this.drawerVisible = true
    },
    handleClose(done) {
      if (this.childFormModified) {
        this.$msgbox.confirm('You have unsaved changes. Are you sure you want to exit?')
            .then(_ => {
              done()
              this.childFormModified = false
            })
            .catch(_ => {})
      } else {
        done()
      }
    },
    triggerDrawerClose() {
      this.handleClose(() => {
        this.drawerVisible = false
        this.targetIntegrationType = null
      })
    },
    triggerForceClose() {
      this.drawerVisible = false
      this.childFormModified = false
    },
  },
}
</script>